<template>
  <div>
    <div class="banner-img">
      <div class="title">
        <div>RESEARCH</div>
        <div class="subtitle">研究内容</div>
      </div>
      <img src="../assets/banner-research.png">
    </div>
    <div class="content-box">
      <!--      <div class="title">Research</div>-->
      <div class="split" />
      <div class="content">
        <p>Mammalian development requires epigenetic specification of hundreds of unique cell types from a single totipotent zygote. How distinct cellular states are established de novo in different cell types during development and how gene regulation contributes to the developmental and phenotypic differences in animals are fundamental questions yet to be answered. Intriguingly, the vast majority of mammalian genomes are noncoding sequences, including regulatory DNA elements, noncoding RNA genes, and repetitive sequences. They are pervasively transcribed to produce thousands of noncoding RNA transcripts.</p>
        <p>Our main research interest is to understand how the noncoding portions of the genome, particularly noncoding RNAs (ncRNAs) and genomic repeats, act with their associated proteins to shape distinct epigenetic and cellular states during stem-cell differentiation and in development. In the past years, we have rigorously investigated novel aspects of ncRNAs, genomic repeats, and RNA-binding proteins (RBPs) in transcription and chromatin regulation in mouse embryonic stem cells (ESCs) and embryos, and revealed important paradigms of noncoding RNA-mediated regulation in transcription and chromatin structure.</p>
        <p>We will continue to elucidate the function and regulation of noncoding RNA, RBPs, and genomic repeats at the molecular and systems levels by using high-throughput integrative approaches across proteomic and genomic systems, together with state-of-art genome editing, imaging, biochemical and single-cell techniques. Our work will help to elucidate fundamental aspects of chromatin and developmental biology, and provide an important framework in which to consider transcription control and cell-fate determination in normal development and disease, and perhaps suggest innovative approaches for disease intervention and to assist manipulation of cell fates for regenerative medicine in future studies.</p>
        <div class="together">
          <p>Main research directions:</p>
          <p>1.	Noncoding RNA and RNA-binding proteins in transcription and chromatin regulation</p>
          <p>2.	Genomic repeats in genome organization and structure</p>
          <p>3.	Regulatory networks in stem-cell pluripotency and embryonic development</p>
        </div>
<!--        <div class="image"><img src="../assets/research.png"></div>-->
        <p>沈晓骅实验室致力于研究人和鼠基因组中的大量非编码核酸序列，探索它们在染色质和基因表达调控中的新颖功能。包括从系统和分子水平上探索非编码RNA、基因组重复序列和RNA结合蛋白，影响转录和染色质高级结构的新模式；从独特的视角来揭示干细胞多能性和细胞命运决定的普适性规律。其研究代表人类认识自身和生命复杂性的一个新方向，将为全面认识个体发育和人类疾病发生提供创新性的理论基础，对认识生物体多样性和进化也具有重要意义。</p>
        <p>近年来主要成果包括：（1）非编码RNA顺式调控邻近转录是基因表达调控的一种普遍模式，为非编码RNA的功能预测提供概念性突破；（2）非编码RNA和RNA结合蛋白是人和鼠染色质的重要成分，在转录过程中被招募并反馈调控转录和染色质结构；（3）基因组重复序列协同调控基因表达和染色质高级结构的新颖功能。</p>
        <div class="together">
          <p>主要研究方向：</p>
          <p>1.	非编码RNA和RBP介导的转录和表观遗传调控</p>
          <p>2.	基因组重复序列与基因表达调控和染色质结构和功能</p>
          <p>3.	干细胞多能性和细胞命运决定的调控网络</p>
        </div>
      </div>
      <div class="split" style="margin: 0 0 10px 0" />
<!--      <div class="bottom">-->
<!--        <span>hits：3657</span>-->
<!--        <span>createDate：2016-01-20 15:00:40</span>-->
<!--        <span>updateDate：2016-03-22 17:26:38</span>-->
<!--      </div>-->
    </div>
  </div>
</template>

<script>
export default {
  name: 'Research'
}
</script>

<style lang="stylus" scoped>
.content-box
  .title
    text-align center
    margin-top 40px
    font-weight 600
    color rgba(31, 46, 65, 1)
    font-size 28px

  .split
    margin 24px 0 16px 0
    height 1px
    background rgba(31, 46, 65, 1)
    opacity 0.2

  .content
    color rgba(31, 46, 65, 1)
    font-size 16px

    p
      margin-bottom 20px
      text-indent 2em
    .together
      margin-bottom 20px
      p
        margin 0;

    .image
      text-align center
      img
       width 65%

  .bottom
    color rgba(31, 46, 65, 1)
    font-size 14px
    margin-bottom 42px
    text-align center
    span
      margin-right 10px
</style>
